import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
// import Permissions from "../mixins/Permissions";

Vue.use(VueRouter);


const guest = (to, from, next) => {
   if (!localStorage.getItem("authToken")) {
      store.dispatch("loader/done");
      return next();
   } else {
      return next("/objednavky");
   }
};
const auth = (to, from, next) => {
   if (localStorage.getItem("authToken")) {
      return next();
   } else {
      store.dispatch("loader/done");
      return next("/login");
   }
};

const routes = [
   //dashboard
   {
      path: "/",
      name: "Home",
      beforeEnter: auth,
      redirect: "/objednavky"
   },

   {
      path: "/login",
      name: "Login",
      meta: { layout: "auth" },
      beforeEnter: guest,
      component: () => import(/* webpackChunkName: "login" */ "../views/auth/login.vue")
   },


   //POUŽÍVATELIA

   {
      path: "/pouzivatelia",
      name: "pouzivatelia",
      // meta: {permissions: 'admin'},
      meta: "Používatelia",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "pouzivatelia" */ "../views/pouzivatelia")
   },

   {
      path: "/pouzivatelia/new",
      name: "new_pouzivatel",
      meta: "Vytvoriť nového používateľa",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "pouzivatelia" */ "../views/pouzivatelia/new.vue")
   },

   {
      path: "/pouzivatelia/:pouzivatel/edit",
      name: "edit_pouzivatel",
      meta: "Edit používateľa",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "pouzivatel" */ "../views/pouzivatelia/_pouzivatel/edit.vue")
   },

   //POLOZKY
   {
      path: "/polozky",
      name: "polozky",
      // meta: {permissions: 'admin'},
      meta: "Položky",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "polozky" */ "../views/polozky")
   },

   {
      path: "/polozky-pouzivatelov",
      name: "polozky-pouzivatelov",
      // meta: {permissions: 'admin'},
      meta: "Položky používateľov",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "polozky-pouzivatelov" */ "../views/polozky-pouzivatelov")
   },
   {
      path: "/rezervacie/new",
      name: "nova-rezervacia",
      // meta: {permissions: 'admin'},
      meta: "Nová rezervácia",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "polozky-pouzivatelov" */ "../views/polozky-pouzivatelov/new-reservation.vue")
   },

   {
      path: "/historia",
      name: "historia",
      // meta: {permissions: 'admin'},
      meta: "Historia",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "historia" */ "../views/historia")
   },

   //SKLADY
   {
      path: "/sklad",
      name: "sklad",
      // meta: {permissions: 'admin'},
      meta: "Sklad",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "sklad" */ "../views/sklad")
   },

   {
      path: "/sklad",
      name: "sklad",
      // meta: {permissions: 'admin'},
      meta: "Sklad",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "sklad" */ "../views/sklad")
   },

   {
      path: "/sklad/sam-prijemka/new",
      name: "new_self_receive_movement",
      // meta: {permissions: 'admin'},
      meta: "Nová samostatná príjemka",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "sklad" */ "../views/sklad/new-sam-prijemka.vue")
   },

   {
      path: "/sklad/sam-vydajka/new",
      name: "new_self_send_movement",
      // meta: {permissions: 'admin'},
      meta: "Nová samostatná výdajka",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "sklad" */ "../views/sklad/new-sam-vydajka.vue")
   },


   //OBJEDNÁVKY

   {
      path: "/objednavky",
      name: "objednavky",
      //meta: {permissions: ['admin']},
      meta: "Objednávky",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "objednavka" */ "../views/objednavky")
   },

   {
      path: "/objednavky/new",
      name: "new_objednavka",
      meta: "Vytvoriť novú objednávku",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "objednavka" */ "../views/objednavky/new.vue")
   },

   {
      path: "/objednavky/:order/edit",
      name: "edit_objednavka",
      meta: "Edit objednávky",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "objednavka" */ "../views/objednavky/_objednavka/edit.vue")
   },
   {
      path: "/objednavky/:order/detail",
      name: "detail_objednavka",
      meta: "Detail objednávky",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "objednavka" */ "../views/objednavky/_objednavka/index.vue")
   },
   {
      path: "/objednavky/:order/nova_prijemka",
      name: "nova_prijemka_objednavky",
      meta: "Vytvoriť príjemku",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "objednavka" */ "../views/objednavky/_objednavka/add_receive_movement.vue")
   },

   {
      path: "/objednavky/:order/nova_vydajka",
      name: "nova_vydajka_objednavky",
      meta: "Vytvoriť výdajku",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "objednavka" */ "../views/objednavky/_objednavka/add_send_movement.vue")
   },

   //NÁVODY

   {
      path: "/navody",
      name: "navody",
      meta: "Návody",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "navody" */ "../views/navody/index.vue")
   },

   //404
   {
      path: "/404",
      name: "404",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "errors-error404" */ "../views/errors/error404.vue"),
      meta: { layout: "auth" }
   },
   {
      path: "/500",
      name: "500",
      beforeEnter: auth,
      component: () => import(/* webpackChunkName: "errors-error500" */ "../views/errors/error500.vue"),
      meta: { layout: "auth" }
   },
   {
      path: "*",
      redirect: "/404"
   }


];

const router = new VueRouter({
   mode: "history",
   linkExactActiveClass: "active",
   routes,
   scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
         return { savedPosition, behavior: "smooth" };
      } else {
         return { x: 0, y: 0, behavior: "smooth" };
      }
   }
});


router.beforeEach((to, from, next) => {
   // console.log(to.meta);
   // if (to.meta && to.meta.permissions && to.meta.permissions instanceof Array
   //     && !to.meta.permissions.filter(permission => Permissions.can(permission))) {
   //     next({name: '404'});
   // } else {
   if (to.meta && to.meta.layout && to.meta.layout === "auth") {
      store.commit("setLayout", "auth");
   } else {
      store.commit("setLayout", "app");
   }
   next(true);
   // }
});

export default router;
